<template>
  <div class="config">
    <portal :target-el="'#' + targetId">
      <div
        v-if="expanded"
        v-on-click-outside="onClickOutside"
        :style="position"
        :class="['fixed', { hidden: hidden }]"
      >
        <slot :max-dimensions="{ maxHeight: maxHeight }"></slot>
      </div>
    </portal>
    <template v-if="!expanded">
      <div class="slot-container">
        <slot :max-dimensions="{}"></slot>
      </div>
    </template>
    <div :class="['controls', { expanded: expanded }]">
      <a class="undecorated toggle" @click.prevent="toggle">
        <span ref="icon" class="af-icons af-icons-chevron-down"></span>
      </a>
    </div>
  </div>
</template>

<script>
import { clickOutside } from 'vue-bootstrap';

export default {
  mixins: [clickOutside],
  props: {
    targetId: {
      type: String,
      default: 'filtertron-tray-external-content'
    }
  },
  data() {
    return {
      expanded: false,
      hidden: true,
      maxHeight: null,
      topPosition: null,
      rightPosition: null
    };
  },
  computed: {
    position() {
      return {
        top: this.topPosition,
        right: this.rightPosition
      };
    }
  },
  beforeDestroy() {
    this.close();
    this.cleanup();
  },
  methods: {
    toggle() {
      this.expanded = !this.expanded;
      this.hidden = true;

      setTimeout(() => {
        const clientRect = this.$refs.icon.getBoundingClientRect();

        const topPosition = Math.round(clientRect.top);
        const rightPosition = Math.round(
          // Take the body width (minus scrollbars) and subtract
          // the toggle control's left position from it
          document.body.clientWidth - clientRect.left + 10
        );
        const maxHeight = Math.round(
          // Take the body height (minus scrollbars) and subtract
          // the toggle control's top position from it
          document.body.clientHeight - clientRect.top - 40
        );

        this.topPosition = `${topPosition}px`;
        this.rightPosition = `${rightPosition}px`;
        this.maxHeight = `${maxHeight}px`;

        this.hidden = false;
      }, 100);
    },
    close() {
      this.expanded = false;
    },
    onClickOutside() {
      const body = document.getElementsByTagName('body')[0];
      const modalOpen = body.className.match(/modal-open/);

      if (!modalOpen) {
        this.close();
      }
    },
    cleanup() {
      const portalContent = document.getElementById(this.targetId);

      if (portalContent.firstChild) {
        portalContent.removeChild(portalContent.firstChild);
      }
    }
  }
};
</script>

<style scoped>
.config {
  position: relative;
}

.slot-container {
  width: calc(100% - 20px);
}

.controls {
  position: absolute;
  top: 0;
  right: 0;
}

.controls .af-icons-chevron-down {
  transform: rotate(-90deg);
}

.controls.expanded .af-icons-chevron-down {
  transform: rotate(90deg);
}

.fixed {
  z-index: 1000;
  position: fixed;
  max-width: 90%;
}
</style>
